import React from "react";
import { FaPhoneAlt } from "react-icons/fa";
import images from "../../Data/images";

const Career = () => {
  return (
    <div className="text-gray-800">

      {/* Hero */}
      <div className="bg-[#c4122f] text-white py-16 px-6 md:px-20">
        <h1 className="text-4xl font-bold mb-4">CAREERS</h1>
        <p className="text-lg max-w-xl">
          Join a Professional Security Team
        </p>
      </div>

      {/* Breadcrumb + Contact */}
      <div className="flex justify-between items-center py-4 px-6 md:px-20 border-b bg-gray-50">
        <span className="text-sm text-gray-500">HOME / CAREERS</span>
        <span className="flex items-center gap-2 text-sm text-gray-700">
          <FaPhoneAlt className="text-[#c4122f]" />
          +1 (416) 477-7692
        </span>
      </div>

      {/* Intro */}
      <section className="py-16 px-6 md:px-20 grid md:grid-cols-2 gap-12 items-center">
        <div>
          <h2 className="text-3xl font-semibold text-[#c4122f] mb-4">
            Join a Professional Security Team
          </h2>

          <p className="mb-4">
            Argus Security International is committed to building a team of
            professional, reliable, and dedicated security personnel.
          </p>

          <p className="mb-4">
            Our guards play an important role in protecting people, property,
            and assets across Ontario while maintaining the highest standards
            of professionalism and service.
          </p>

          <p>
            We are always interested in connecting with individuals who are
            responsible, disciplined, and committed to maintaining safe
            environments.
          </p>
        </div>

        <img
          src={images.s6}
          alt="Argus Security Careers"
          className="rounded-xl shadow-lg"
        />
      </section>

      {/* Opportunities */}
      <section className="py-16 px-6 md:px-20 bg-gray-50">
        <h2 className="text-3xl font-semibold text-[#c4122f] mb-6">
          Opportunities at Argus Security
        </h2>

        <p className="mb-4">
          Argus Security provides a variety of security roles across different
          environments.
        </p>

        <p className="mb-4 font-semibold">Positions may include:</p>

        <ul className="grid md:grid-cols-2 gap-3 list-disc list-inside">
          <li>Uniformed Security Guards</li>
          <li>Mobile Patrol Officers</li>
          <li>Concierge / Front Desk Security</li>
          <li>Construction Site Security</li>
          <li>Gatehouse Security Officers</li>
          <li>Loss Prevention Officers</li>
          <li>Event Security Personnel</li>
        </ul>
      </section>

      {/* What We Look For */}
      <section className="py-16 px-6 md:px-20 grid md:grid-cols-2 gap-12 items-start">
        <div>
          <h2 className="text-3xl font-semibold text-[#c4122f] mb-6">
            What We Look For
          </h2>

          <p className="mb-4">
            Argus Security seeks individuals who demonstrate:
          </p>

          <ul className="space-y-3">
            <li>✔ Professional appearance and conduct</li>
            <li>✔ Strong communication skills</li>
            <li>✔ Attention to detail and situational awareness</li>
            <li>✔ Reliability and accountability</li>
            <li>✔ Ability to remain calm and professional under pressure</li>
          </ul>

          <p className="mt-6">
            Security personnel represent both Argus Security and the clients
            we serve, so professionalism is essential.
          </p>
        </div>

        <img
          src={images.s0}
          alt="Security Personnel"
          className="rounded-xl shadow-lg"
        />
      </section>

      {/* Requirements */}
      <section className="py-16 px-6 md:px-20 bg-gray-50">
        <h2 className="text-3xl font-semibold text-[#c4122f] mb-6">
          Requirements
        </h2>

        <p className="mb-4">
          Applicants should typically possess:
        </p>

        <ul className="grid md:grid-cols-2 gap-3 list-disc list-inside">
          <li>Valid Ontario Security Guard License</li>
          <li>Strong communication and customer service skills</li>
          <li>Ability to write clear incident reports</li>
          <li>Professional appearance and demeanor</li>
          <li>Availability for shifts including evenings or weekends</li>
        </ul>

        <p className="mt-6">
          Additional training or experience in security, customer service, or
          public safety may be considered an asset.
        </p>
      </section>

      {/* Professional Development */}
      <section className="py-16 px-6 md:px-20">
        <h2 className="text-3xl font-semibold text-[#c4122f] mb-6">
          Professional Development
        </h2>

        <p className="mb-4">
          Argus Security supports the continued development of our team members
          through:
        </p>

        <ul className="list-disc list-inside space-y-2">
          <li>Site-specific training</li>
          <li>Operational guidance and supervision</li>
          <li>Opportunities to gain experience across different security environments</li>
        </ul>

        <p className="mt-6">
          Our goal is to build a team of security professionals who take pride
          in their work and maintain high standards of service.
        </p>
      </section>

      {/* Apply Section */}
      <section className="bg-[#c4122f] text-white py-16 px-6 md:px-20 text-center">
        <h2 className="text-3xl font-semibold mb-4">
          Apply to Join Argus Security
        </h2>

        <p className="max-w-2xl mx-auto mb-6">
          If you are interested in joining our team, please submit your resume
          and relevant information through our application process.
        </p>

        <p className="mb-6">
          We review applications regularly and will contact qualified
          candidates regarding available opportunities.
        </p>

        <p className="text-lg font-semibold mb-6">
          📧 info@argussecurity.ca
        </p>

        <a
          href="mailto:info@argussecurity.ca"
          className="bg-white text-[#c4122f] px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition"
        >
          Send Your Resume
        </a>
      </section>

    </div>
  );
};

export default Career;